// extracted by mini-css-extract-plugin
export default {"logoutBtn":"Logout_logoutBtn__4LCng","icon":"Logout_icon__V0TWl"};